import { format } from "date-fns";
import type { Locale } from "date-fns";

/** 区间标题(桌面两周/手机横屏单周共用)：中文「2026/07 13–26」「2026/07/27 – 2026/08/09」，英文按英语语序日在前「13–26 Jul 2026」「27 Jul – 2 Aug 2026」 */
export function formatRange(first: Date, last: Date, isEnglish: boolean, locale: Locale): string {
  const sameYear = first.getFullYear() === last.getFullYear();
  const sameMonth = sameYear && first.getMonth() === last.getMonth();
  if (isEnglish) {
    if (sameMonth) {
      return `${format(first, 'd')}–${format(last, 'd')} ${format(last, 'MMM yyyy', { locale })}`;
    }
    // 跨年时开始端也补年份，否则「28 Dec – 10 Jan 2027」看不出起点是 2026
    const firstPattern = sameYear ? 'd MMM' : 'd MMM yyyy';
    return `${format(first, firstPattern, { locale })} – ${format(last, 'd MMM yyyy', { locale })}`;
  }
  return sameMonth
    ? `${format(first, 'yyyy/MM')} ${format(first, 'd')}–${format(last, 'd')}`
    : `${format(first, 'yyyy/MM/dd')} – ${format(last, 'yyyy/MM/dd')}`;
}
